import api from "@/lib/api";

export interface PostUpdatepassContractRequest {
  setupIntentId: string;
  planCode: string;
  planPriceId: string;
  price: string;
  serial: string;
  contractNumber: string;
  freeTrialType: string;
  countryCode: string;
  currencyCode: string;
}

export interface PostUpdatepassContractResponse {
  contractNumber: string;
  status: string;
  message_type: string;
  errorCode: string;
}

export default {
  postUpdatepassContract(data: PostUpdatepassContractRequest) {
    return api<PostUpdatepassContractRequest, PostUpdatepassContractResponse>({
      endpoint: "updatepass/web-api/updatepass-contract",
      method: "POST",
      body: data
    });
  }
};
